'use strict'

const promisify = require('promisify-es6')

module.exports = (send) => {
  return promisify((opts, callback) => {
    if (typeof (opts) === 'function') {
      callback = opts
      opts = {}
    }

    send({
      path: 'diag/cmds',
      qs: opts
    }, callback)
  })
}



//////////////////
// WEBPACK FOOTER
// ./src/diag/cmds.js
// module id = 341
// module chunks = 0